import { render } from "./TableColumnsFilter.vue?vue&type=template&id=5e20b63e"
import script from "./TableColumnsFilter.vue?vue&type=script&lang=js"
export * from "./TableColumnsFilter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__